import { useQuery } from 'react-query';

import { ContentBlock, KimMessageType } from '../../../../backend/src/types/types';
import { APIBaseChronos } from '@/api/hosts';
import { ApiError, QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export interface KimMessage {
  id: string;
  type: KimMessageType;
  content: ContentBlock[];
  createdDate: string;
}

export const useGetKimMessages = (matterId?: string, subsetId?: string, threadId?: string) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<KimMessage[], ApiError>(
    [QueryEntity.KimMessages, { threadId }],
    async () => {
      const res = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/kim/threads/${threadId}/messages`,
        fetchConfigGET,
      );
      if (!res.ok) {
        const error = await res.json();
        throw new ApiError(error.code, error.message);
      }
      return res.json();
    },
    {
      enabled: !!matterId && !!subsetId && !!threadId,
      refetchOnWindowFocus: false,
    },
  );
};
